module.exports = __webpack_public_path__ + "img/utility-pole-double.62ce7ee3.svg";